import { render, staticRenderFns } from "./PersonalDealers.vue?vue&type=template&id=63db240e&"
import script from "./PersonalDealers.vue?vue&type=script&lang=js&"
export * from "./PersonalDealers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports